module.exports = __webpack_public_path__ + "img/dq.1e262e45.png";